import React from 'react';
import { round_to, useHover } from '../utils';
import { colors } from '../styles';

const Area = ({
  active,
  chart_height,
  onClick,
  origin,
  round,
  spacing,
  stroke_width,
}) => {
  const dots = active.map(({ color, label, raw, value, id }, index) => {
    const circle_x = round_to(origin.x + index * spacing, 0);
    const circle_y = round_to(chart_height - value, 0);
    const radius = 3 * stroke_width;
    return (
      <g key={id}>
        <circle
          style={{ cursor: 'pointer' }}
          onClick={() => onClick({ raw, label })}
          cx={circle_x}
          cy={circle_y}
          r={radius}
          strokeWidth="0"
          fill={color}
        />
      </g>
    );
  });

  const polygon = (
    <polygon
      strokeWidth={stroke_width}
      stroke={colors.grey}
      fill={colors.grey}
      points={`${active
        .map(v => v.value)
        .map((p, i) => `${origin.x + i * spacing},${chart_height - p}`)
        .join(' ')}
            ${origin.x + (active.length - 1) * spacing},${chart_height}
            0,${chart_height}
            `}
    />
  );

  return (
    <g
      aria-hidden="true"
      strokeLinecap={round ? 'round' : 'butt'}
      strokeLinejoin={round ? 'round' : 'miter'}
    >
      <g>{polygon}</g>
      {dots}
    </g>
  );
};
export default Area;
